const USER_TOKEN = 'token'
const USER_INFO = 'userInfo'
export const getUser = () => { return JSON.parse(window.localStorage.getItem(USER_TOKEN)) }
export const setUser = (data) => { window.localStorage.setItem(USER_TOKEN, JSON.stringify(data)) }
export const removeUser = () => { return window.localStorage.removeItem(USER_TOKEN) }

export const getUserInfo = () => { return JSON.parse(window.sessionStorage.getItem(USER_INFO)) }
export const setUserInfo = (data) => { window.sessionStorage.setItem(USER_INFO, JSON.stringify(data)) }
export const removeUserInfo = () => { return window.sessionStorage.removeItem(USER_INFO) }